import { RenterPolicyConfigurationDto } from "../../../../networking/data/responses/renterPolicy/RenterPolicyConfigurationDto";

export class RenterPolicyConfiguration {
    public readonly durationInHours: number;
    public readonly insuranceDurationInDays: number;
    public readonly maxSequentialUnActivePeriods: number;
    public readonly requiredUpgradePoints: number;

    public constructor(dto: RenterPolicyConfigurationDto) {
        this.durationInHours = dto.durationInHours;
        this.insuranceDurationInDays = dto.insuranceDurationInDays;
        this.maxSequentialUnActivePeriods = dto.maxSequentialUnActivePeriods;
        this.requiredUpgradePoints = dto.requiredUpgradePoints;
    }
}
